import React from "react";

type testimonialCardProps = {
  img?: string;
  name?: string;
  message?: string;
  title?: string;
  inSlide?: boolean;
};

const TestimonialCard = ({ img, name, message, title, inSlide = true }: testimonialCardProps) => {
  return (
    <React.Fragment>
      <div className="card">
        <img src={img} alt={title} className="profile" />
        <div className="profile-details">
          <div className="name">{name}</div>
          <div className="title">{title}</div>
          <div className="message">{message}</div>
        </div>
      </div>
      <style jsx>{`
        .card {
          margin: ${inSlide ? "12px" : "12px 0 12px 0"};
          height: 200px;
          width: 460px;
          box-shadow: 0 2px 4px 0 rgba(64, 64, 64, 0.2);
          border-radius: 8px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
        }
        .profile {
          height: 120px;
          border-radius: 50%;
          border: 1px solid #f0f0f0;
          display: flex;
          margin: 0 2rem;
        }
        .profile-details {
          display: flex;
          flex-direction: column;
        }
        .name {
          font-size: 16px;
          font-weight: bold;
        }
        .title {
          font-size: 13px;
          margin-bottom: 8px;
          border-bottom: 1px solid #f4f4f4;
          margin-right: 8px;
        }
        .message {
          font-size: 13px;
          margin-right: 8px;
        }
        @media only screen and (max-width: 910px) {
          .card {
            height: 250px;
            width: ${inSlide ? "300px" : "auto"};
          }
          .profile {
            height: 80px;
            margin: 0 1rem;
          }
        }
        @media only screen and (max-width: 330px) {
          .card {
            display: flex;
            flex-direction: column;
            padding: 8px;
            width: ${inSlide ? "200px" : "auto"};
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default TestimonialCard;
